import { Badge } from '@/components/ui/badge';
import type { ImportOrderStatus } from '../types/import-tracking.types';

const STATUS_CONFIG: Record<
  ImportOrderStatus,
  {
    label: string;
    variant: 'default' | 'secondary' | 'destructive' | 'outline' | 'success' | 'warning' | 'info';
    className?: string;
  }
> = {
  QUOTE: { label: 'Cotización', variant: 'outline', className: 'border-info-borde text-primary' },
  DRAFT: { label: 'Borrador', variant: 'secondary' },
  CONFIRMED: { label: 'Confirmada', variant: 'info' },
  SHIPPED: { label: 'Embarcada', variant: 'info' },
  IN_TRANSIT: { label: 'En tránsito', variant: 'warning' },
  CUSTOMS: { label: 'En aduana', variant: 'warning' },
  CUSTOMS_HOLD: { label: 'Retenida en aduana', variant: 'destructive' },
  DELIVERED: { label: 'Entregada', variant: 'success' },
  CANCELLED: { label: 'Cancelada', variant: 'destructive' },
};

interface ImportStatusBadgeProps {
  status: ImportOrderStatus;
  className?: string;
}

export function ImportStatusBadge({ status, className }: ImportStatusBadgeProps) {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.DRAFT;

  return (
    <Badge variant={config.variant} className={`${config.className ?? ''} ${className ?? ''}`}>
      {config.label}
    </Badge>
  );
}
